import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useProfile } from "@/context/ProfileContext";
import { useOnboardingDraft } from "@/hooks/queries/use-onboarding-draft";
import { hasProductAccess } from "@/utils/productAccess";

/**
 * "Ert konto är aktiverat - bjud in till testet": shown to an owner or admin
 * whose onboarding stopped at the invite step while Intelligence was not yet
 * activated (GRA-173). Disappears once the invitations are sent.
 */
export function PendingInvitesBanner() {
  const { t } = useTranslation("onboarding");
  const { businessProfile, memberRole } = useProfile();
  const canInvite = memberRole === "owner" || memberRole === "admin";
  const entitled = hasProductAccess(businessProfile, "intelligence", Date.now());
  const draft = useOnboardingDraft(canInvite && entitled ? businessProfile?.uid : undefined);
  const pending =
    draft.data?.draft?.currentStep === "invite" && !draft.data.draft.invitations?.submittedBatchId;
  if (!pending) return null;

  return (
    <div
      className="flex flex-col gap-2 border-b border-border bg-primary/10 px-4 py-3 sm:flex-row sm:items-center sm:justify-between"
      data-testid="pending-invites-banner"
    >
      <div className="flex items-center gap-3 text-sm">
        <Sparkles className="h-4 w-4 text-primary" aria-hidden="true" />
        <span>
          <span className="font-semibold">{t("banner.title")}</span> {t("banner.body")}
        </span>
      </div>
      <Button asChild size="sm">
        <Link to="/onboarding?s=invite">{t("banner.cta")}</Link>
      </Button>
    </div>
  );
}
